import type {
  FindFlightOffersFlightSegmentV2,
  FindFlightOffersSegment,
  FindUserReservationsFlightReservationSegment,
  GetFlightAvailabilityTokenSegment,
} from "../types/codegen";

type Segment =
  | GetFlightAvailabilityTokenSegment
  | FindFlightOffersSegment
  | FindUserReservationsFlightReservationSegment
  | FindFlightOffersFlightSegmentV2;

const isReservationSegment = (
  segment: Segment,
): segment is FindUserReservationsFlightReservationSegment => {
  return "origin" in segment && "destination" in segment;
};

export function extractAirlineCarriers<
  T extends
    | GetFlightAvailabilityTokenSegment
    | FindFlightOffersSegment
    | FindUserReservationsFlightReservationSegment
    | FindFlightOffersFlightSegmentV2,
>(segments: T[]) {
  const carriers = segments?.map((segment) => {
    if (isReservationSegment(segment)) {
      if (!segment.marketingCarrier) {
        return null;
      }

      return {
        ...segment.marketingCarrier,
        flightNumber: segment.flightNumber,
        operatingCarrier: {
          ...segment.operatingCarrier,
          flightNumber: segment.flightNumber,
        },
      };
    }

    return {
      ...segment.marketingCarrier.airline,
      flightNumber: segment.marketingCarrier.flightNumber,
      operatingCarrier: {
        ...segment.operatingCarrier?.airline,
        flightNumber: segment.operatingCarrier?.flightNumber,
      },
    };
  });

  // Remove duplicates based on airline code and flight number
  const uniqueCarriers = carriers
    ?.filter((x): x is NonNullable<typeof x> => Boolean(x))
    .filter(
      (carrier, index, self) =>
        index === self.findIndex((t) => t.code === carrier.code),
    );

  return uniqueCarriers || null;
}
